const drawCircleChart = (
  ctx: any,
  centerX: any,
  centerY: any,
  radius: any,
  graphDelayPercent: any,
  graphSubsPercent: any,
  lineWidth: any,
  emptyStrokeType: any,
  fullStrokeType: any,
  subsColor: any
) => {
  ctx.beginPath();
  ctx.strokeStyle = emptyStrokeType;
  ctx.lineWidth = lineWidth;
  ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
  ctx.stroke();
  ctx.closePath();

  ctx.beginPath();
  ctx.strokeStyle = fullStrokeType;
  ctx.lineCap = 'butt';
  ctx.lineWidth = lineWidth;
  ctx.arc(
    centerX,
    centerY,
    radius,
    0.5 * Math.PI,
    (0.5 + 2 * graphDelayPercent) * Math.PI
  );
  ctx.stroke();
  ctx.closePath();

  ctx.beginPath();
  ctx.strokeStyle = subsColor;
  ctx.lineCap = 'butt';
  ctx.lineWidth = lineWidth;
  ctx.arc(
    centerX,
    centerY,
    radius,
    (0.5 + 2 * graphDelayPercent) * Math.PI,
    (0.5 + 2 * graphDelayPercent + 2 * graphSubsPercent) * Math.PI,
    false
  );
  ctx.stroke();
  ctx.closePath();
};

export default drawCircleChart;
